<template lang="pug">
a(v-bind='$props', v-if='!!to && to.indexOf("javascript") < 0' @click='$emit("click", $event)')
  router-link(:to='to')
    slot
a(:class='buttonClass', v-bind='$props', v-else-if='!!href' @click='$emit("click", $event)')
  slot
button.dawn-button(:class='buttonClass', v-bind='$props', @click='$emit("click", $event)', v-else)
  slot
</template>

<script>

export default {
  name: 'ed-button',
  props: {
    type: {
      type: String,
      default: 'button'
    },
    disabled: Boolean,
    href: String,
    to: String,
    buttonClass: {
      type: String,
      default: 'btn btn-primary'
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

button, html [type="button"], [type="reset"], [type="submit"] {
  -webkit-appearance: none;
}

//a, .dawn-button {
//  @extend .btn;
//}

/*.theme.skin*/ .btn,
/*.theme.skin*/ a.btn {
  border: none;
  border-radius: $border-radius;
  position: relative;
  padding: 8px 22px;
  margin: 10px 2px;
  font-size: $font-size-medium;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0;
  box-shadow: none;

  &::-moz-focus-inner {
    border: 0;
  }

  &[disabled] {
    //cursor: not-allowed;
    //pointer-events: none;
  }

  &.cta {
    display: block;
    width: 100%;
  }

  &.alt, &.btn-primary.alt {
    @include theme {
      @include btn-styles($primary-alt);
      color: $canvas;
      border: none;
    }
  }

  &,
  &.btn-default {
    @include theme {
      @include btn-styles(v(ink-light))
    }
  }

  &.btn-primary {
    @include theme {
      @include btn-styles(v(primary-05))
    }
    a {
      @include theme {
      color: v(canvas);
      }
    }
  }

  &.btn-secondary {
    @include theme {
      @include btn-styles(v(ink-light))
    }
    a {
      @include theme {
      color: v(canvas);
      }
    }
    &.alt {
      color: $ink;
      background-color: $background-light;
      border: 1px solid $border;
      &:hover, &:active, &:focus {
        background-color: $canvas;
        color: $ink;
        border-color: $ink;
      }
    }
  }

  &.btn-info {
    @include theme {
      @include btn-styles(v(secondary-01))
    }
  }

  &.btn-success {
    @include theme {
      @include btn-styles(v(tertiary-01))
    }
  }

  &.btn-warning {
    @include theme {
      @include btn-styles(v(urgent-01))
    }
  }

  &.btn-danger {
    @include theme {
      @include btn-styles(v(urgent-01))
    }
  }

  &.btn-white {
    &,
    &:focus,
    &:hover {
      @include theme {
      color: v(ink-light);
      background-color: v(canvas);
      }
    }
    &.btn-simple {
      @include theme {
      color: v(canvas);
      }
      background: transparent;
      box-shadow: none;
    }
  }

  &.btn-lg,
  .btn-group-lg & {
    padding: 18px 36px;
    font-size: $font-size-large;
  }

  &.btn-sm,
  .btn-group-sm & {
    padding: 5px 20px;
    font-size: $font-size-xsmall;
  }

  &.btn-xs,
  .btn-group-xs & {
    padding: 4px 15px;
    font-size: $font-size-xsmall;
  }

  &.btn-just-icon {
    font-size: 20px;
    padding: 12px 12px;
    line-height: 1em;

    i {
      width: 20px;
    }
    &.btn-lg {
      font-size: 22px;
      padding: 13px 18px;
    }
  }

  &.btn.btn-border {
    @include theme {
    box-shadow: inset 0 0 0 1px v(background);
    &:hover {
      box-shadow: inset 0 0 0 1px v(urgent-01);
    }
    }
  }

  &.btn.btn-actionbar {
    &, &-primary {
      @include theme {
      color: v(ink);
      background: v(canvas);
      border-color: v(background);
      }
      font-weight: 600;
      border: $border-default;
      padding: 4px 12px;
      font-size: 11px;
      border-radius: $border-radius - .5rem;

      &:hover, &:active, &:focus {
        @include theme {
        color: v(ink);
        background: v(canvas);
        border-color: v(border);
        }
        box-shadow: none;
      }
      & > a {
        @include theme {
        color: v(ink);
        }
        font-size: 11px;
        font-weight: 600;
        background: none;
        line-height: normal;
        margin: -4px -12px;
        padding: 4px 12px;
        box-shadow: none;
      }
    }
    &.alt {
      color: $canvas;
      background-color: $primary-alt;
      &:hover, &:active, &:focus {
        background-color: $ink;
        color: $canvas;
      }
    }
    &-primary {
      @include theme {
      color: v(canvas);
      background: v(primary-05);
      border-color: v(primary-05);
      }
      &:hover {
        &:hover, &:active, &:focus {
          @include theme {
          color: v(canvas);
          background: lighten(v(primary-05), 20%);
          border-color: v(primary-05);
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/core/components/edButton/index.vue